var render = function render() {
    var _vm_repayObj, _vm_repayObj1, _vm_repayObj2, _vm_repayObj3;
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('x-popup', {
        style: {
            width: '80%',
            padding: '24px 24px 60px'
        },
        attrs: {
            "value": _vm.value,
            "title": "Detalle de cargos",
            "safeAreaInsetBottom": true,
            "close-on-click-overlay": false,
            "position": "center",
            "teleport": "body",
            "round": ""
        },
        on: {
            "opened": _setup.onOpenedPopup,
            "closed": _setup.onClosedPopup,
            "click-close-icon": function($event) {
                return _setup.emit('close');
            }
        }
    }, [
        _c('div', [
            _c('ul', {
                class: _vm.$style.detailBox
            }, [
                _c('li', [
                    _c('span', [
                        _vm._v("Monto principal")
                    ]),
                    _c('span', [
                        _vm._v("$ " + _vm._s(_setup.formatAmount(((_vm_repayObj = _vm.repayObj) === null || _vm_repayObj === void 0 ? void 0 : _vm_repayObj.debtPrincipalSum) || 0)))
                    ])
                ]),
                _c('li', [
                    _c('span', [
                        _vm._v("Interés")
                    ]),
                    _c('span', [
                        _vm._v("$ " + _vm._s(_setup.formatAmount(((_vm_repayObj1 = _vm.repayObj) === null || _vm_repayObj1 === void 0 ? void 0 : _vm_repayObj1.debtBalance) || 0)))
                    ])
                ]),
                _c('li', [
                    _c('span', [
                        _vm._v("Cargo por garantia")
                    ]),
                    _c('span', [
                        _vm._v("$ " + _vm._s(_setup.formatAmount(((_vm_repayObj2 = _vm.repayObj) === null || _vm_repayObj2 === void 0 ? void 0 : _vm_repayObj2.debtDbf) || 0)))
                    ])
                ]),
                _c('li', [
                    _c('span', [
                        _vm._v("Cargo por gestión")
                    ]),
                    _c('span', [
                        _vm._v("$ " + _vm._s(_setup.formatAmount(((_vm_repayObj3 = _vm.repayObj) === null || _vm_repayObj3 === void 0 ? void 0 : _vm_repayObj3.debtFwf) || 0)))
                    ])
                ])
            ]),
            _c('div', {
                class: _vm.$style.btn,
                on: {
                    "click": function($event) {
                        return _setup.emit('close');
                    }
                }
            }, [
                _vm._v("OK")
            ])
        ])
    ]);
};
var staticRenderFns = [];
export { render, staticRenderFns };
